// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"e1c632d2","561":"ea9c68ba","667":"91406919","788":"0b35eef6","890":"97e16ad1","977":"264c7fbf"}[chunkId] + ".chunk.js";
};